import { type ReactElement } from "react";

import markOnly from "../assets/vidario-icon.svg";
import logoWithWordmark from "../assets/vidario-logo.svg";
import { cn } from "../utils/cn";

export interface VidarioLogoProps {
  size?: number;
  withText?: boolean;
  className?: string;
}

/** The official Vidario brand mark.
 *
 * Both variants are SVG: the artwork is circles, two connector bars and
 * letterforms, so it stays crisp at any size and any DPI, and the pair costs
 * ~3 KB gzipped against the 162 KB the previous PNG lockup shipped on every
 * screen — including login, before a user is even authenticated.
 *
 * `withText` picks the lockup (wordmark + mark) or the mark alone. `size` is a
 * HEIGHT in px for the lockup, which keeps its own aspect ratio; the mark is
 * square, so size is both dimensions. */
export function VidarioLogo({
  size = 28,
  withText = true,
  className,
}: VidarioLogoProps): ReactElement {
  const src = withText ? logoWithWordmark : markOnly;
  return (
    <img
      src={src}
      alt="Vidario"
      style={withText ? { height: `${size}px` } : { height: `${size}px`, width: `${size}px` }}
      className={cn("inline-block select-none", withText && "w-auto", className)}
      draggable={false}
    />
  );
}
